import { z } from "zod";

import { LIST_FEEDBACK_STATUSES } from "../constants/list-feedback-status.js";

// ── List feedback (#717): a client's comment on a list, as the admin page reads it ──

export const ListFeedbackStatusSchema = z.enum(LIST_FEEDBACK_STATUSES);

export const ListFeedbackResponseSchema = z.object({
    id: z.uuid(),
    list_id: z.uuid(),
    list_name: z.string(),
    licence_id: z.uuid(),
    licence_name: z.string(),
    author_name: z.string(),
    content: z.string(),
    created_at: z.string(),
    status: ListFeedbackStatusSchema,
});
export type ListFeedbackResponse = z.infer<typeof ListFeedbackResponseSchema>;

export const ListFeedbackListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(ListFeedbackResponseSchema),
});

export const ListFeedbackSingleResponseSchema = z.object({
    success: z.boolean(),
    data: ListFeedbackResponseSchema,
});

// ── Status update ──

export const UpdateListFeedbackStatusRequestSchema = z.object({
    status: ListFeedbackStatusSchema,
});
export type UpdateListFeedbackStatusRequest = z.infer<typeof UpdateListFeedbackStatusRequestSchema>;

// ── Sidebar badge: how many feedbacks are still Open ──

export const ListFeedbackOpenCountResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({ count: z.number().int() }),
});
